import React from "react";
import { css } from "@emotion/css";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Button, Grid, Typography } from "@mui/material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import design_heading from "../../assets/site/landing/design_heading.webp";
import phone_icon from "../../assets/site/landing/phone.png";
import mail_icon from "../../assets/site/landing/mail.png";
import image_instagram from "../../assets/site/image_instagram.png";
import image_linkedin from "../../assets/site/linkedin.png";
import { config } from "../../env/config";
import { MediaImage, SectionHeading } from "../../common/typography";

const supportTextStyle = css({
    color: "#48255D",
    fontStyle: "Open Sans, Medium",
    fontSize: "16px",
});

const contactBtnStyle = {
    textTransform: "none",
    background: "#F9C5B4",
    width: "234px",
    color: "black",
    borderRadius: "30px",
    display: "flex",
    columnGap: "15px",
};

export const ContactUs = () => (
    <Grid item xs={12}>
        <SectionHeading sx={{ marginBottom: 0 }}>contact us</SectionHeading>
        <div style={{ textAlign: "center" }}>
            <MediaImage
                src={design_heading}
                sx={{
                    width: { xs: 230, md: 275 },
                    height: { xs: 26, md: 35 },
                }}
            />
        </div>

        <Container maxWidth="md" sx={{ pt: 3, pb: 5 }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "20px",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        columnGap: "20px",
                        rowGap: "10px",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "center",
                    }}
                >
                    <MediaImage
                        src={phone_icon}
                        sx={{
                            width: { xs: "50px", md: "73px" },
                            height: { xs: "30px", md: "41px" },
                        }}
                    />
                    <Button
                        href={
                            config.env === "global"
                                ? "tel:+19173997899"
                                : "tel:+919503692077"
                        }
                        variant="contained"
                        style={contactBtnStyle}
                    >
                        <LocalPhoneIcon />
                        <Typography
                            component="p"
                            variant="p"
                            className={supportTextStyle}
                        >
                            {config.env === "global"
                                ? "+1 (917) 399-7899"
                                : "+91 9503692077"}
                        </Typography>
                    </Button>
                    <Button
                        href="tel:+919619013322"
                        variant="contained"
                        style={contactBtnStyle}
                    >
                        <LocalPhoneIcon />
                        <Typography
                            component="p"
                            variant="p"
                            className={supportTextStyle}
                        >
                            +91 9619013322
                        </Typography>
                    </Button>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        columnGap: "20px",
                        rowGap: "10px",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "center",
                    }}
                >
                    <MediaImage
                        src={mail_icon}
                        sx={{
                            width: { xs: "50px", md: "73px" },
                            height: { xs: "30px", md: "41px" },
                        }}
                    />
                    <Button
                        style={{
                            textTransform: "none",
                        }}
                        color="secondary"
                        href="mailto:contactus@divineharmony.co.in?subject=info"
                    >
                        <Typography
                            component="p"
                            variant="p"
                            color="#066FC7"
                            fontSize="20px"
                            className={supportTextStyle}
                        >
                            contactus@divineharmony.co.in
                        </Typography>
                    </Button>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                            component="p"
                            variant="p"
                            fontSize="18px"
                            fontFamily="sans-serif"
                        >
                            Follow Us @
                        </Typography>
                        <Button
                            variant="text"
                            target="_blank"
                            href="https://www.instagram.com/divine_harmony_with_shreekalp/"
                        >
                            <Box
                                component="img"
                                alt="Instagram"
                                width="32px"
                                height="32px"
                                src={image_instagram}
                            />
                        </Button>
                        <Button
                            variant="text"
                            target="_blank"
                            href="https://www.linkedin.com/company/spiritual-meeting/"
                        >
                            <Box
                                component="img"
                                alt="Instagram"
                                width="32px"
                                height="32px"
                                src={image_linkedin}
                            />
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Container>
    </Grid>
);
